import React from 'react';
import { SMPContainer, SMPFlex } from '@velinsi/smp-widgets-ui';

interface EventContainerProps {
  children: React.ReactNode;
  displayOdds: boolean;
}

export const EventContainer: React.FC<EventContainerProps> = ({ children, displayOdds }) => {
  return (
    <SMPContainer
      css={{
        m: '0',
        p: '0',
        borderRight: '1px solid $borderMultiSportColor',
      }}
    >
      <SMPFlex
        direction='column'
        justify='start'
        align='start'
        gap={'sm'}
        css={{ minWidth: '165px', padding: displayOdds ? '6px 8px' : '8px' }}
      >
        {children}
      </SMPFlex>
    </SMPContainer>
  );
};
